import styled from 'styled-components'

export default styled.section`
  align-items: center;
  background: #304760;
  display: flex;
  padding: 3em 0;
`



// WEBPACK FOOTER //
// ./src/components/ContactForm.js